import { defineStore } from 'pinia';
import { Permission } from '@fhtwl-admin/system';
import { ACCESS_TOKEN, encryptionField } from './const';
import { login, logout } from '@/api/system/auth';
import { getUserInfo } from '@/api/system/user';
import { getEnvironmentData } from '@/utils/env';
import { generatorDynamicRouter } from '@/router/modules/generatorRouters';
import { PageView, AdminLayout } from '@/layouts';
import { SystemMenuItem } from '@/components/SystemHead';
import { foreachTree } from '@/utils/utils';
import { TreeNode, filterTreeByKey } from '@/utils/tree';
export const loginApiPrefix =
  (window as unknown as { config: { loginApiPrefix: string } }).config
    .loginApiPrefix || 'sso';

export interface UserInfo {
  idcard: string;
  name: string;
  orgCode: string;
  orgName: string;
  policeNumber: string;
}

export interface Menu {
  key: string;
  name: string;
  children: Menu[];
}

const defaultUserInfo = {
  idcard: '',
  name: '',
  orgCode: '',
  orgName: '',
  policeNumber: '',
};

export const userStore = defineStore('user', {
  state: () => ({
    token: localStorage.getItem(ACCESS_TOKEN),
    name: '',
    avatar: '',
    role: [] as UserRes.StoreRole[],
    info: {
      ...defaultUserInfo,
    } as UserInfo,
    email: '',
    menuList: [] as SystemMenuItem[],
    menus: [] as UserRes.GetUserMenu[],
    openId: '',
    addRouters: (localStorage.getItem('addRouters')
      ? JSON.stringify(localStorage.getItem('addRouters'))
      : []) as Common.Router[],
    // 系统设置子菜单
    systemSettingMenuList: [] as SystemMenuItem[],
    isHideSensitiveFields: false,
    isShowDownload: false,
  }),
  getters: {
    // nameLength: (state) => state.name.length,
    // // 是否隐藏敏感字段
    // isHideSensitiveFields: (state) =>
    //   state.role.find((r) => r.roleCode === 'ds_ywy'),
    // isShowDownload: (state) =>
    //   state.role.find((r) => ['ds_bjypy', 'ds_xtgly'].includes(r.roleCode)),
  },
  actions: {
    getUserInfo(): Promise<string> {
      return new Promise((resolve, reject) => {
        fetch(`${loginApiPrefix}/user/all_info`)
          .then((res) => res.json())
          .then((res) => {
            const { menu, role, idcard, name, orgCode, orgName, policeNumber } =
              res.data as {
                menu: {
                  default: string;
                  menus: UserRes.GetUserMenu[];
                  module: {
                    export: boolean;
                    fields_encode: boolean;
                  };
                };
                role: UserRes.StoreRole[];
                idcard: string;
                name: string;
                orgCode: string;
                orgName: string;
                policeNumber: string;
              };
            this.isHideSensitiveFields = menu.module.fields_encode;
            this.isShowDownload = menu.module.export;
            this.role = role;
            console.log(res.data);
            this.setUserInfo({ idcard, name, orgCode, orgName, policeNumber });
            if (!menu.default) {
              reject('没有默认菜单');
            }
            this.addRouters = [
              {
                path: '/',
                redirect: menu.default, // '/policeSituation',
              },
              {
                path: '/policeSituation',
                component: AdminLayout,
                redirect: menu.default,
                children: [
                  ...generatorDynamicRouter(
                    filterTreeByKey(menu.menus, (node: TreeNode) => {
                      return node.isGrey !== true;
                    }) as UserRes.GetUserMenu[]
                  ),
                ],
              },
            ] as unknown as Common.Router[];
            this.menus = menu.menus;
            this.menuList = res.data.menu.menus;

            foreachTree(this.menuList, (item) => {
              if (item.key === '/policeSituation/systemSetting') {
                this.systemSettingMenuList =
                  item.children as unknown as SystemMenuItem[];
              }
            });

            localStorage.setItem('addRouters', JSON.stringify(this.addRouters));
            console.log('userUseStore.addRouters', this.addRouters);
            resolve(menu.default);
          });
      });
    },
    // 退出登录
    async logout() {
      return new Promise((resolve, reject) => {
        fetch(`/${loginApiPrefix}/logout`)
          .then((res) => res.text())
          .then((res) => {
            this.info = {
              ...defaultUserInfo,
            };
            console.log(res);
            window.location.href = res;
          });
        // logout()
        //   .then(() => {
        //     this.token = '';
        //     localStorage.removeItem(ACCESS_TOKEN);
        //     resolve(undefined);
        //   })
        //   .catch((error: Error) => {
        //     reject(error);
        //   });
      });
    },
    setUserInfo(data: UserInfo) {
      console.log('setUserInfo', data);
      this.info = data;
    },

    deleteToken() {
      this.token = null;
      localStorage.removeItem(ACCESS_TOKEN);
    },
  },
});

// 运维员无法查看报警电话，报警地址，报警内容，反馈内容
export const transformCellText = ({
  text,
  column,
}: {
  text: string;
  column: { dataIndex: string; title: string };
}) => {
  const systemUserStore = userStore();

  if (
    systemUserStore.isHideSensitiveFields &&
    encryptionField.includes(column.title)
  ) {
    return '***';
  }
  return text;
};
